import { Component, input, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ContentType } from '@mira-avant/mtlibs';
import { DropdownControl } from '../../../controls/setup-wizard/dropdown-control/dropdown-control';

@Component({
	selector: 'app-content-type-dropdown-field',
	imports: [DropdownControl],
	standalone: true,
	templateUrl: './content-type-dropdown-field.html',
	styleUrl: './content-type-dropdown-field.scss',
})
export class ContentTypeDropdownField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
	options = signal<{ value: string; label: string }[]>(
		Object.values(ContentType).map(value => ({ value, label: value }))
	);
}
